import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchLaundryReported = createAsyncThunk(
  "laundryReported/fetchLaundryReported",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/reported", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const laundryReportedSlice = createSlice({
  name: "laundryReported",
  initialState: {
    laundryReporteds: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLaundryReported.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchLaundryReported.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.laundryReporteds = action.payload.data;
      })
      .addCase(fetchLaundryReported.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch laundryReporteds";
      });
  },
});

export default laundryReportedSlice.reducer;
